<template>
  <div>
    <el-card style="height:100vh">
      <div class="nav-header">
        <div class="item active">规格管理</div>
        <div class="item " @click="$router.push('/merchantProductRecipes')">
          做法管理
        </div>
        <div
          class="item"
          @click="$router.push('/merchantProductFeedingManagement')"
        >
          加料管理
        </div>
        <!-- <div class="item">餐盒管理</div>
            <div class="item">单位管理</div>
            <div class="item">标签管理</div> -->
      </div>
      <div class="but-item">
        <el-button class="item" @click="addGuiGe">新建规格</el-button>
        <!-- <el-button class="item white">排序</el-button> -->
      </div>
      <div class="search">
        <span>规格名称:</span>
        <input
          type="text"
          @focus="inputActive = true"
          @blur="inputActive = false"
          :class="{ active: inputActive }"
        />
        <el-button style="background:#ffbd00;color:#000;height:32px">
          <i class="el-icon-search"></i>
          查询</el-button
        >
        <el-button style="height:32px">重置</el-button>
      </div>
      <!-- 表格区域 -->
      <div style="margin-top:36px">
        <el-table
          height="52vh"
          :data="tableData"
          width="100%"
          v-loading="tableLoading"
        >
          <el-table-column width="70" align="center" label="序号" type="index">
          </el-table-column>
          <el-table-column align="center" prop="dimName" label="规格名称">
          </el-table-column>
          <!-- <el-table-column width="120" label="关联菜品数量"></el-table-column> -->
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-popconfirm
                title="确认删除吗？"
                :ref="scope.$index"
                @onConfirm="deleteTable(scope.row.id)"
              >
                <span slot="reference" style="color:#fe8c00;cursor:pointer"
                  >删除</span
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <el-dialog title="新建规格" :visible.sync="dialogVisible" width="520px">
        <div class="flex-right">
          <el-form>
            <el-form-item class="flex-form-item" label="规格名称:" required>
              <el-input v-model="dimName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="cancel" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="addSpecs">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      total: 0,
      tableLoading: true,
      dimName: "",
      dimType: "specs", //此处固定 practice 做法 specs规格
      inputActive: false,
      merchantCode: "",
      merchantName: "",
      dialogVisible: false,
      tableData: [],
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          merchantCode: "",
          merchantName: "",
          dimType: "specs"
        }
      }
    };
  },
  methods: {
    addGuiGe() {
      this.dimName = "";
      this.dialogVisible = true;
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },
    // 新增规格
    addSpecs() {
      var data = {};
      data.merchantCode = this.merchantCode;
      data.merchantName = this.merchantName;
      data.dimName = this.dimName;
      data.dimType = this.dimType;
      this.$http.post("/merchantDim/save", data).then(res => {
        if (res.data.code == 200) {
          this.$message({ type: "success", message: "保存成功" });
          this.getListData();
          this.dialogVisible = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getListData() {
      this.$http.post("/merchantDim/list", this.queryInfo).then(res => {
        this.tableLoading = false;
        this.tableData = res.data.data.data;
        this.total = res.data.data.count;
      });
    },
    //删除
    deleteTable(id) {
      this.$http.post("merchantDim/delete", { id }).then(res => {
        console.log(res);
        if (res.data.code == 200) {
          this.$message({ type: "success", message: "删除成功" });
          this.getListData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    }
  },
  created() {
    this.merchantCode = localStorage.getItem("merchantCode");
    this.merchantName = localStorage.getItem("merchantName");
    this.queryInfo.condition.merchantCode = localStorage.getItem(
      "merchantCode"
    );
    this.queryInfo.condition.merchantName = localStorage.getItem(
      "merchantName"
    );
    this.getListData();
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.nav-header {
  display: flex;

  .item {
    cursor: pointer;
    height: 46px;
    line-height: 46px;
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 2px solid transparent;
    color: rgb(51, 51, 51);
    transition: 0.5s;
    border-bottom: 3px solid transparent;
  }

  .item.active {
    border-bottom: 3px solid #ffbd00;
    color: rgb(0, 0, 0);
  }

  .item:hover {
    border-bottom-color: #ffbd00;
    color: rgb(0, 0, 0);
  }
}

.but-item {
  margin-top: 24px;
  margin-bottom: 24px;

  .item {
    font-size: 14px;
    height: 36px;
    line-height: 36px;
    background-color: rgb(255, 189, 0);
    color: #000;
    margin-left: 12px;
    border-radius: 4px;
  }

  .item:hover {
    background-color: rgb(255, 189, 0, 0.6);
  }

  .item.white {
    background-color: #fff;
  }
}

.search {
  padding-left: 12px;
  height: 32px;
  line-height: 32px;

  span {
    color: #333;
    font-size: 14px;
    margin-right: 8px;
  }

  input {
    box-sizing: border-box;
    outline: none;
    height: 32px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    padding: 4px 11px;
    width: 183px;
    margin-right: 16px;
  }

  input.active {
    border-color: #ffcd29;
  }
}

/deep/ thead {
  tr {
    th {
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
}

/deep/ .flex-form-item {
  display: flex;

  .el-form-item__content {
    font-size: 14px;
    width: 352px;
    height: 40px;

    input {
      height: 32px !important;
      line-height: 32px !important;
    }
  }
}

/deep/ .flex-right {
  display: flex;
  justify-content: right;
}

/deep/ .dialog-footer {
  button {
    height: 32px;
    line-height: 32px;
    background-color: #ffbd00;
    border: 1px solid #ffbd00;
    color: #000;
  }

  button.cancel {
    border: 1px solid #dcdfe6;
    background-color: #fff;
  }

  button.cancel:hover {
    color: #fe8c00;
  }
}

/deep/ table {
  font-size: 14px;
}
</style>
